import React from "react";
import { Tooltip, Zoom } from "@mui/material";
import { CardGiftcard } from "@mui/icons-material";
import { keyframes, styled } from "@mui/system";
import palette from "../../theme/palette";

interface GiftButtonProps {
  hasGift: boolean;
  onActivateGift: () => void;
}

const bounce = keyframes`
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-10px); }
`;

const AnimatedGift = styled("div")`
  position: fixed;
  bottom: 40px;
  right: 40px;
  z-index: 2000;
  cursor: pointer;
  animation: ${bounce} 1.5s infinite ease-in-out;
  background-color: ${palette.primary.main};
  border-radius: 50%;
  padding: 16px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.25);
  transition: transform 0.2s;

  &:hover {
    transform: scale(1.1);
    animation: none;
  }

  svg {
    color: white;
    font-size: 36px;
  }

  /* Acima do bottom-nav (64px + safe area): antes o botão sentava em cima do
     último item da barra ("Histórico") e bloqueava o toque. */
  @media (max-width: 959.95px) {
    bottom: calc(64px + env(safe-area-inset-bottom) + 16px);
    right: 16px;
    padding: 10px;
    box-shadow: 0 3px 10px rgba(0, 0, 0, 0.2);

    svg {
      font-size: 28px;
    }
  }
`;

export const GiftButton: React.FC<GiftButtonProps> = ({ hasGift, onActivateGift }) => {
    if (!hasGift) return null
  return (
    <>
        <Tooltip
            title="Você recebeu um presente!"
            placement="top"
            TransitionComponent={Zoom}
            arrow
        >
            <AnimatedGift onClick={onActivateGift}>
                <CardGiftcard />
            </AnimatedGift>
        </Tooltip>
    </>
  );
};
